import { render, staticRenderFns } from "./WebMenu.vue?vue&type=template&id=9ef1f780"
import script from "./WebMenu.vue?vue&type=script&lang=js"
export * from "./WebMenu.vue?vue&type=script&lang=js"
import style0 from "./WebMenu.vue?vue&type=style&index=0&id=9ef1f780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports